/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseUserWeeklyScheduleDto } from '../../models/response-user-weekly-schedule-dto';
import { UpdateUserWeeklyScheduleDto } from '../../models/update-user-weekly-schedule-dto';

export interface UserWeeklyScheduleControllerUpdate$Params {

/**
 * Tenant identifier
 */
  tenant: string;

/**
 * User email
 */
  email: string;
      body: UpdateUserWeeklyScheduleDto
}

export function userWeeklyScheduleControllerUpdate(http: HttpClient, rootUrl: string, params: UserWeeklyScheduleControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseUserWeeklyScheduleDto>> {
  const rb = new RequestBuilder(rootUrl, userWeeklyScheduleControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('email', params.email, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseUserWeeklyScheduleDto>;
    })
  );
}

userWeeklyScheduleControllerUpdate.PATH = '/thalea-google-events/user-weekly-schedule/{tenant}/{email}';
